import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { DisputeDiffSectionLabels } from '@pay-bill/components';

export const DisputeDiffSection = ({
  mode,
  children,
}: {
  mode: 'form' | 'view';
  children: React.ReactNode;
}) => {
  return (
    <div className="DisputeDiffSection">
      <div className="shift-info">
        <DisputeDiffSectionLabels mode={mode} />
        {children}
      </div>
      <style jsx global>
        {`
          .DisputeDiffSection .shift-info {
            background-color: ${Colors.steelLightest};
            padding-top: 12px;
            padding-left: 12px;
            padding-right: 12px;
          }
          .DisputeDiffSection .table-form {
            margin-top: 8px;
          }
          .DisputeDiffSection s,
          .DisputeDiffSection .table-label {
            color: ${Colors.midnightLighter};
          }
          .DisputeDiffSection .table-row {
            padding-bottom: 8px;
          }
          .DisputeDiffSection .ant-form-item {
            margin-bottom: 12px;
          }
          .DisputeDiffSection .rate-line {
            padding-top: 5px;
            display: block;
          }
        `}
      </style>
    </div>
  );
};
